import { useMemo, StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";

import "@/assets/index.css";
import { routes } from "@/router";

// Only initialize Sentry in production (not in local development)
if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://88c14122153ce5294d74b5986a0dc93d@o75771.ingest.us.sentry.io/4507173509267456",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllInputs: false,
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/dekobase\.cc\/api/,
      /^https:\/\/tickecdzfrelikxshmux\.supabase\.co\/rest/,
    ],
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

const rootElement = document.getElementById("root");

function Main(): React.JSX.Element {
  const router = useMemo(() => createBrowserRouter(routes), []);
  return <RouterProvider router={router} />;
}

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <StrictMode>
      <Main />
    </StrictMode>,
  );
}
